import styled from 'styled-components';
import useIosA2hs from '../../hooks/useIosA2hs';
import { ReactComponent as A2hsIcon } from '../../assets/images/icons/a2hs.svg';

const A2hsModalContainer = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: clamp(280px, 92vw, 640px);
  border-radius: 1rem;
  background-color: var(--tonal);
  backdrop-filter: blur(8px);
  padding: 1rem;
  z-index: 9999;

  @media screen and (max-width: 768px) {
    bottom: calc(1rem + env(safe-area-inset-bottom));
    width: clamp(280px, 92vw, 500px);
  }
`;

const ModalTitle = styled.div`
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
`;

const InstructionList = styled.ol`
  font-size: 0.875rem;
  color: var(--text-secondary);
  list-style: decimal;
  padding-left: 1.25rem;
  margin: 0;

  li {
    margin-bottom: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: var(--text-primary);
      font-weight: 600;
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
      flex-shrink: 0;
    }
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

const Button = styled.button<{ $primary?: boolean }>`
  flex: 1;
  padding: 0.625rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background-color: ${(props) => (props.$primary ? 'var(--filled-blue-light)' : 'var(--tonal)')};
  color: ${(props) => (props.$primary ? 'var(--text-primary)' : 'var(--text-primary)')};

  &:hover {
    background-color: ${(props) => (props.$primary ? 'var(--filled-blue-deep)' : 'var(--tonal-deep)')};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export default function IosA2hsModal() {
  const { shouldShow, suppress } = useIosA2hs();
  if (!shouldShow) return null;

  return (
    <A2hsModalContainer role='dialog' aria-live='polite'>
      <ModalTitle>홈 화면에 추가하면 더 빠르게 열 수 있어요</ModalTitle>
      <InstructionList>
        <li>1. Safari로 이 페이지를 열어주세요</li>
        <li>
          2. 하단 <strong>공유</strong> 버튼 <A2hsIcon /> 을 탭
        </li>
        <li>
          3. <strong>홈 화면에 추가</strong> 선택 → <strong>추가</strong>
        </li>
      </InstructionList>

      <ButtonGroup>
        <Button type='button' onClick={() => suppress(7)}>
          일주일간 보지 않기
        </Button>
        <Button type='button' $primary onClick={() => suppress(0)}>
          닫기
        </Button>
      </ButtonGroup>
    </A2hsModalContainer>
  );
}
